module.exports = __webpack_public_path__ + "img/RFA-Logo.6bd697cf.png";